import(/* webpackMode: "eager", webpackExports: ["BlogPostClient"] */ "/vercel/path0/app/[locale]/blog/[slug]/BlogPostClient.tsx");
